export const API_URL = 'https://spendwise-backend-e2cs.onrender.com'